<template>
  <div>
    <div class="container">

      <div class="columns mt-01">

        <div class="column">
          <iframe class="frame-pdf" src="https://croccancun.com/assets/pdf/INFORME-SOCIAL-Y-TESORERIA-2021-2022.pdf?v=1.1" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Programas',
  data () {
    return {

    }
  },
  computed: {
  },
  components: {

  },
  mounted() {

  },
  methods:{

  },
  created :function(){
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Programas.vue